<script lang="ts">
export default {
  name: 'NumberInput',
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { computed, useAttrs } from 'vue';
import { addCommas } from '@/utilities/Number';

const props = defineProps<{
  modelValue: string | number | null | undefined;
}>();

const emit = defineEmits<{
  'update:modelValue': [string | number | null | undefined]
}>();

const attrs = useAttrs();

const computedValue = computed({
  get() {
    let str = '';
    if (props.modelValue !== undefined && props.modelValue !== null) {
      str = addCommas(props.modelValue);
    }
    return str;
  },
  set(val: string | number | null | undefined) {
    const v = typeof val === 'string' ? val.replaceAll(',', '') : val;
    const input = isNaN(Number(v)) || v === '' ? '' : Number(v);
    emit('update:modelValue', input);
  }
});
</script>

<template>
  <div :data-testid="attrs['data-parent-test']">
    <v-text-field density="compact" variant="outlined" v-bind="attrs" v-model="computedValue">
      <template v-slot:append>
        <slot name="append" />
      </template>
      <template v-slot:prepend>
        <slot name="prepend" />
      </template>
    </v-text-field>
  </div>
</template>

